/**
 * @generated SignedSource<<5e87551d4d4b55ceabb5419d888beb41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VotesOrder = "mostRecent" | "mostVotes" | "%future added value";
export type VotesCastPanelPaginationQuery$variables = {
  after?: string | null;
  first?: number | null;
  orderBy: VotesOrder;
  proposalId: string;
};
export type VotesCastPanelPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"VotesCastPanelVotesFragment">;
};
export type VotesCastPanelPaginationQuery = {
  response: VotesCastPanelPaginationQuery$data;
  variables: VotesCastPanelPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 30,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "proposalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "proposalId",
    "variableName": "proposalId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Address",
    "kind": "LinkedField",
    "name": "address",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ResolvedName",
        "kind": "LinkedField",
        "name": "resolvedName",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VotesCastPanelPaginationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "VotesCastPanelVotesFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VotesCastPanelPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VotesConnection",
        "kind": "LinkedField",
        "name": "votes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VotesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Vote",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Delegate",
                    "kind": "LinkedField",
                    "name": "executor",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VotingPower",
                    "kind": "LinkedField",
                    "name": "votes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TokenAmount",
                        "kind": "LinkedField",
                        "name": "amount",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "amount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Delegate",
                    "kind": "LinkedField",
                    "name": "voter",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportDetailed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "proposalId",
          "orderBy"
        ],
        "handle": "connection",
        "key": "VotesCastPanelFragment_votes",
        "kind": "LinkedHandle",
        "name": "votes"
      }
    ]
  },
  "params": {
    "cacheID": "6e68d846e856cd643da746a39a0fa273",
    "id": null,
    "metadata": {},
    "name": "VotesCastPanelPaginationQuery",
    "operationKind": "query",
    "text": "query VotesCastPanelPaginationQuery(\n  $after: String\n  $first: Int = 30\n  $orderBy: VotesOrder!\n  $proposalId: ID!\n) {\n  ...VotesCastPanelVotesFragment_1OhugP\n}\n\nfragment NounResolvedLinkFragment on ResolvedName {\n  address\n  name\n  ...NounResolvedNameFragment\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment VoteReasonFragment on Vote {\n  reason\n}\n\nfragment VoteRowFragment on Vote {\n  id\n  reason\n  votes {\n    amount {\n      amount\n    }\n  }\n  voter {\n    address {\n      address\n      resolvedName {\n        address\n        ...NounResolvedLinkFragment\n      }\n    }\n    id\n  }\n  executor {\n    address {\n      address\n      resolvedName {\n        address\n        ...NounResolvedLinkFragment\n      }\n    }\n    id\n  }\n  ...VoteRowTextFragment\n  ...VoteReasonFragment\n}\n\nfragment VoteRowTextFragment on Vote {\n  supportDetailed\n}\n\nfragment VotesCastPanelVotesFragment_1OhugP on Query {\n  votes(proposalId: $proposalId, orderBy: $orderBy, first: $first, after: $after) {\n    edges {\n      node {\n        executor {\n          address {\n            address\n          }\n          id\n        }\n        ...VoteRowFragment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f1acf1d8acdcd149dadcfa2ce7d1508";

export default node;
